/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { ClubDetailItemFragment } from '@amf/shared/types/graphql';
import Container from '@amf/shared/components/layout/Container';

interface ClubHeaderProps {
  club: ClubDetailItemFragment;
}

function ClubHeader({ club }: ClubHeaderProps) {
  return (
    <div className='ClubHeader'>
      <div className='ClubHeader__overlay'>
        <Container className='ClubHeader__container'>
          <div className='ClubHeader__content'>
            <div className='ClubHeader__about'>
              {club.brandUrl && (
                <img className='ClubHeader__brand' src={club.brandUrl} alt={club.name} />
              )}
              <div>
                <h1 className='ClubHeader__title'>{club.name}</h1>
              </div>
            </div>
            <div className='ClubHeader__crosses'>
              <div className='ClubHeader__cross' />
              <div className='ClubHeader__cross' />
              <div className='ClubHeader__cross' />
              <div className='ClubHeader__cross' />
              <div className='ClubHeader__cross' />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default ClubHeader;
